import CustomLoader from "@/components/Loader/CustomLoader";
import { useListAdCreative } from "@/modules/Asset/Creative/asset.hook";
import * as React from "react";
import { useLocation } from "react-router-dom";
import CreateCampaign from "./CreateCampaign";
import EditCampaign from "./EditCampaign";
import { getCreativeGroupAdIds } from "./data";

export default function CreateOrEditCampaign({
  isEdit = false,
}: CreateOrEditConversionProps): ReturnType<React.FC> {
  const location = useLocation();
  const campaign = JSON.parse(location?.state?.data ?? null);
  const {
    data: creatives,
    isLoading: creativesLoading,
    isFetching: creativesFetching,
  } = useListAdCreative({
    type: "display",
    enabled: Boolean(isEdit && campaign),
    queryParams: {
      advertiserId: Number(campaign?.advertiserId),
      adType: Number(campaign?.lineItemType) ?? 0,
      isPagination: false,
      isGrouped: true,
    },
  });
  let creativeGroupAdIds = null;
  if (isEdit && creatives) {
    creativeGroupAdIds = getCreativeGroupAdIds({
      creativeList: creatives?.rows,
      creativeIds: campaign.creatives,
    });
  }

  return (
    <>
      {" "}
      {isEdit ? (
        campaign ? (
          creativesLoading && creativesFetching ? (
            <CustomLoader />
          ) : (
            <EditCampaign
              campaign={campaign}
              creativeGroupAdIds={creativeGroupAdIds}
            />
          )
        ) : null
      ) : (
        <CreateCampaign />
      )}{" "}
    </>
  );
}

interface CreateOrEditConversionProps {
  isEdit?: boolean;
}
